import { useStarterDashboardV2PageData } from 'src/app/pages/starterDashboardV2/pageContext';

type UsePetitionOverviewReturn = ModelHookResult<{
	strengthTipsEnabled: boolean;
}>;

export function usePetitionOverview(): UsePetitionOverviewReturn {
	const {
		data: {
			featureConfigs: { strengthTipsEnabled },
		},
	} = useStarterDashboardV2PageData();

	return {
		data: {
			strengthTipsEnabled,
		},
	};
}
